exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".display-coordinates-plugin-popup{display:flex;align-items:center;justify-content:space-between;padding:0;margin:0;border:0}.display-coordinates-plugin-popup .display-coordinates-plugin-popup__text{font-size:12px}.display-coordinates-plugin-popup .display-coordinates-plugin-popup__icon{font-size:16px;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/display-coordinates-plugin-popup.scss
// module id = 159
// module chunks = 4